/*
  Place lookup for the pop-up salon tour page. Loaded by lac-tour-search.js.
  Split out from the search so the tables can be edited without touching the
  logic, and so the whole thing can be exercised by a test harness.

  window.LAC_GEO = { TOUR, CITY, STATE, ZIP, resolve(text) }

  resolve() returns { pt: [lat, lng], label, broad } or null.
  "broad" means we only placed them to a state or a ZIP region, not a point,
  so the answer says "about N miles from the middle of Ohio" rather than
  promising a drive time from their front door.

  ORDER MATTERS, and the reasons are all real bugs that happened:
    1. ZIP first, because a 5 digit number is unambiguous.
    2. Commas are stripped before every lookup. "charleston sc" and
       "Charleston, SC" have to reach the same entry, or a woman in Charleston
       gets sent to Spartanburg because "sc" matched the state.
    3. Cities before states on an exact match, so "New York" is the city.
    4. Longest leading run before single state tokens, so "Fargo ND" is Fargo
       and not the middle of North Dakota.
    5. Whole token state matching only after that, so "sc" alone still works
       but never steals a city name off the front of the string.
*/
(function () {
  var TOUR = {
    'ashburn, va':[39.04,-77.49],'billings, mt':[45.78,-108.50],'seattle, wa':[47.61,-122.33],
    'portland, or':[45.52,-122.68],'boise, id':[43.62,-116.20],'orlando, fl':[28.54,-81.38],
    'chicago, il':[41.88,-87.63],'columbus, oh':[39.96,-83.00],'detroit, mi':[42.33,-83.05],
    'nashville, tn':[36.16,-86.78],'milwaukee, wi':[43.04,-87.91],'minneapolis, mn':[44.98,-93.27],
    'indianapolis, in':[39.77,-86.16],'hartford, ct':[41.76,-72.69],'st. louis, mo':[38.63,-90.20],
    'sioux falls, sd':[43.55,-96.73],'omaha, ne':[41.26,-95.93],'denver, co':[39.74,-104.98],
    'phoenix, az':[33.45,-112.07],'birmingham, al':[33.52,-86.80],'charleston, sc':[32.78,-79.93],
    'myrtle beach, sc':[33.69,-78.89],'atlanta, ga':[33.75,-84.39],'palm beach, fl':[26.71,-80.05],
    'houston, tx':[29.76,-95.37],'austin, tx':[30.27,-97.74],'dallas, tx':[32.78,-96.80],
    'spartanburg, sc':[34.95,-81.93],'tallahassee, fl':[30.44,-84.28],'baton rouge, la':[30.45,-91.19],
    'san antonio, tx':[29.42,-98.49],'jackson, ms':[32.30,-90.18],'memphis, tn':[35.15,-90.05],
    'knoxville, tn':[35.96,-83.92],'richmond, va':[37.54,-77.44],'kansas city, mo':[39.10,-94.58],
    'little rock, ar':[34.75,-92.29],'oklahoma city, ok':[35.47,-97.52],'sacramento, ca':[38.58,-121.49],
    'las vegas, nv':[36.17,-115.14],'san diego, ca':[32.72,-117.16],'new jersey':[40.50,-74.45],
    'long island, ny':[40.78,-73.35],'alexandria, va':[38.80,-77.05],'boston, ma':[42.36,-71.06],
    'philadelphia, pa':[39.95,-75.17],'salt lake city, ut':[40.76,-111.89],'albuquerque, nm':[35.08,-106.65],
    'lexington, ky':[38.04,-84.50],'raleigh, nc':[35.78,-78.64],'chattanooga, tn':[35.05,-85.31],
    'orange county, ca':[33.70,-117.83],'new orleans, la':[29.95,-90.07],'jacksonville, fl':[30.33,-81.66],
    'miami, fl':[25.76,-80.19]
  };

  /* Bare city names, plus "<city> <state abbr>" keys wherever the bare name is
     ambiguous, so Springfield IL and Springfield MO both land correctly and the
     bare word falls to the biggest one. */
  var CITY = {
    'new york':[40.71,-74.01],'new york city':[40.71,-74.01],'nyc':[40.71,-74.01],
    'manhattan':[40.78,-73.97],'brooklyn':[40.68,-73.94],'queens':[40.73,-73.79],
    'bronx':[40.84,-73.87],'staten island':[40.58,-74.15],'buffalo':[42.89,-78.88],
    'rochester':[43.16,-77.61],'rochester ny':[43.16,-77.61],'rochester mn':[44.02,-92.47],
    'syracuse':[43.05,-76.15],'albany':[42.65,-73.76],'albany ny':[42.65,-73.76],'albany ga':[31.58,-84.16],
    'yonkers':[40.93,-73.90],'white plains':[41.03,-73.76],'poughkeepsie':[41.70,-73.92],'ithaca':[42.44,-76.50],
    'los angeles':[34.05,-118.24],'la ca':[34.05,-118.24],'san francisco':[37.77,-122.42],
    'san jose':[37.34,-121.89],'oakland':[37.80,-122.27],'fresno':[36.75,-119.77],
    'long beach':[33.77,-118.19],'bakersfield':[35.37,-119.02],'anaheim':[33.84,-117.91],
    'santa ana':[33.75,-117.87],'irvine':[33.68,-117.83],'riverside':[33.95,-117.40],
    'stockton':[37.96,-121.29],'chula vista':[32.64,-117.08],'fremont':[37.55,-121.99],
    'san bernardino':[34.11,-117.29],'modesto':[37.64,-120.99],'santa barbara':[34.42,-119.70],
    'palm springs':[33.83,-116.55],'santa clarita':[34.39,-118.54],'oxnard':[34.20,-119.18],
    'pasadena':[34.15,-118.14],'pasadena ca':[34.15,-118.14],'pasadena tx':[29.69,-95.21],
    'glendale':[34.14,-118.26],'glendale ca':[34.14,-118.26],'glendale az':[33.54,-112.19],
    'santa rosa':[38.44,-122.71],'salinas':[36.68,-121.66],'san luis obispo':[35.28,-120.66],
    'redding':[40.59,-122.39],'chico':[39.73,-121.84],'eureka':[40.80,-124.16],
    'fort worth':[32.76,-97.33],'el paso':[31.76,-106.49],'corpus christi':[27.80,-97.40],
    'plano':[33.02,-96.70],'lubbock':[33.58,-101.86],'amarillo':[35.22,-101.83],'mcallen':[26.20,-98.23],
    'arlington':[32.74,-97.11],'arlington tx':[32.74,-97.11],'arlington va':[38.88,-77.10],
    'waco':[31.55,-97.15],'tyler':[32.35,-95.30],'midland':[31.997,-102.08],'odessa':[31.85,-102.37],
    'brownsville':[25.90,-97.50],'laredo':[27.51,-99.51],'killeen':[31.12,-97.73],'college station':[30.63,-96.33],
    'naperville':[41.79,-88.15],'peoria':[40.69,-89.59],'peoria il':[40.69,-89.59],'peoria az':[33.58,-112.24],
    'rockford':[42.27,-89.09],'champaign':[40.12,-88.24],'springfield':[39.80,-89.64],
    'springfield il':[39.80,-89.64],'springfield mo':[37.21,-93.29],'springfield ma':[42.10,-72.59],
    'springfield oh':[39.92,-83.81],'aurora':[41.76,-88.32],'aurora il':[41.76,-88.32],'aurora co':[39.73,-104.83],
    'joliet':[41.53,-88.08],'evanston':[42.05,-87.68],'bloomington':[40.48,-88.99],
    'bloomington il':[40.48,-88.99],'bloomington in':[39.17,-86.53],'bloomington mn':[44.84,-93.30],
    'tucson':[32.22,-110.97],'mesa':[33.42,-111.83],'scottsdale':[33.49,-111.93],
    'chandler':[33.31,-111.84],'gilbert':[33.35,-111.79],'flagstaff':[35.20,-111.65],'yuma':[32.69,-114.63],
    'pittsburgh':[40.44,-79.99],'allentown':[40.61,-75.49],'erie':[42.13,-80.09],
    'harrisburg':[40.27,-76.88],'scranton':[41.41,-75.66],'lancaster':[40.04,-76.31],
    'lancaster pa':[40.04,-76.31],'reading':[40.34,-75.93],'bethlehem':[40.63,-75.38],'state college':[40.79,-77.86],
    'tampa':[27.95,-82.46],'st petersburg':[27.77,-82.64],'saint petersburg':[27.77,-82.64],
    'fort lauderdale':[26.12,-80.14],'naples':[26.14,-81.79],'sarasota':[27.34,-82.53],
    'fort myers':[26.64,-81.87],'gainesville':[29.65,-82.32],'gainesville fl':[29.65,-82.32],
    'gainesville ga':[34.30,-83.82],'pensacola':[30.42,-87.22],'west palm beach':[26.71,-80.05],
    'boca raton':[26.37,-80.10],'ocala':[29.19,-82.14],'daytona beach':[29.21,-81.02],
    'lakeland':[28.04,-81.95],'port st lucie':[27.27,-80.35],'key west':[24.56,-81.78],'melbourne':[28.08,-80.61],
    'cleveland':[41.50,-81.69],'cincinnati':[39.10,-84.51],'toledo':[41.65,-83.54],
    'akron':[41.08,-81.52],'dayton':[39.76,-84.19],'youngstown':[41.10,-80.65],'canton':[40.80,-81.38],
    'athens':[33.96,-83.38],'athens ga':[33.96,-83.38],'athens oh':[39.33,-82.10],
    'fort wayne':[41.08,-85.14],'evansville':[37.97,-87.56],'south bend':[41.68,-86.25],
    'terre haute':[39.47,-87.41],'muncie':[40.19,-85.39],'lafayette':[30.22,-92.02],
    'lafayette la':[30.22,-92.02],'lafayette in':[40.42,-86.89],
    'grand rapids':[42.96,-85.67],'ann arbor':[42.28,-83.74],'lansing':[42.73,-84.56],
    'flint':[43.01,-83.69],'traverse city':[44.76,-85.62],'kalamazoo':[42.29,-85.59],'saginaw':[43.42,-83.95],
    'madison':[43.07,-89.40],'green bay':[44.51,-88.02],'appleton':[44.26,-88.42],'eau claire':[44.81,-91.50],
    'st paul':[44.95,-93.09],'saint paul':[44.95,-93.09],'duluth':[46.79,-92.10],'st cloud':[45.56,-94.16],
    'lincoln':[40.81,-96.68],'des moines':[41.59,-93.62],'cedar rapids':[41.98,-91.67],
    'davenport':[41.52,-90.58],'sioux city':[42.50,-96.40],'iowa city':[41.66,-91.53],
    'rapid city':[44.08,-103.23],'fargo':[46.88,-96.79],'bismarck':[46.81,-100.78],'grand forks':[47.93,-97.03],
    'minot':[48.23,-101.30],'aberdeen':[45.46,-98.49],'pierre':[44.37,-100.35],
    'colorado springs':[38.83,-104.82],'fort collins':[40.59,-105.08],'boulder':[40.01,-105.27],
    'pueblo':[38.25,-104.61],'grand junction':[39.06,-108.55],'durango':[37.27,-107.88],
    'provo':[40.23,-111.66],'ogden':[41.22,-111.97],'st george':[37.10,-113.58],'moab':[38.57,-109.55],
    'reno':[39.53,-119.81],'henderson':[36.04,-114.98],'carson city':[39.16,-119.77],
    'santa fe':[35.69,-105.94],'las cruces':[32.31,-106.78],'roswell':[33.39,-104.52],'farmington':[36.73,-108.22],
    'idaho falls':[43.49,-112.03],'twin falls':[42.56,-114.46],'pocatello':[42.87,-112.45],
    'coeur dalene':[47.68,-116.78],'coeur d alene':[47.68,-116.78],
    'spokane':[47.66,-117.43],'tacoma':[47.25,-122.44],'bellevue':[47.61,-122.20],
    'olympia':[47.04,-122.90],'yakima':[46.60,-120.51],'bellingham':[48.75,-122.48],
    'vancouver wa':[45.64,-122.66],'everett':[47.98,-122.20],'kennewick':[46.21,-119.14],
    'eugene':[44.05,-123.09],'bend':[44.06,-121.31],'medford':[42.33,-122.87],
    'salem':[44.94,-123.04],'salem or':[44.94,-123.04],'salem ma':[42.52,-70.90],
    'portland me':[43.66,-70.26],'corvallis':[44.56,-123.26],
    'missoula':[46.87,-113.99],'bozeman':[45.68,-111.04],'great falls':[47.51,-111.30],
    'helena':[46.59,-112.04],'kalispell':[48.20,-114.31],'butte':[46.00,-112.53],
    'cheyenne':[41.14,-104.82],'casper':[42.87,-106.31],'jackson wy':[43.48,-110.76],'laramie':[41.31,-105.59],
    'anchorage':[61.22,-149.90],'fairbanks':[64.84,-147.72],'juneau':[58.30,-134.42],
    'honolulu':[21.31,-157.86],'hilo':[19.71,-155.08],'kahului':[20.89,-156.47],
    'savannah':[32.08,-81.09],'augusta':[33.47,-81.97],'augusta ga':[33.47,-81.97],'augusta me':[44.31,-69.78],
    'macon':[32.84,-83.63],'columbus ga':[32.46,-84.99],'valdosta':[30.83,-83.28],'rome ga':[34.26,-85.16],
    'charlotte':[35.23,-80.84],'greensboro':[36.07,-79.79],'durham':[35.99,-78.90],
    'winston salem':[36.10,-80.24],'asheville':[35.60,-82.55],'wilmington nc':[34.23,-77.94],
    'fayetteville':[36.06,-94.16],'fayetteville ar':[36.06,-94.16],'fayetteville nc':[35.05,-78.88],
    'greenville':[34.85,-82.39],'greenville sc':[34.85,-82.39],'greenville nc':[35.61,-77.37],
    'burlington':[44.48,-73.21],'burlington vt':[44.48,-73.21],'burlington nc':[36.10,-79.44],
    'columbia':[34.00,-81.03],'columbia sc':[34.00,-81.03],'columbia mo':[38.95,-92.33],
    'charleston':[32.78,-79.93],'charleston wv':[38.35,-81.63],
    'hilton head':[32.19,-80.75],'rock hill':[34.92,-81.03],'florence sc':[34.20,-79.76],
    'florence':[34.20,-79.76],'florence al':[34.80,-87.68],'anderson':[34.50,-82.65],'aiken':[33.56,-81.72],
    'louisville':[38.25,-85.76],'bowling green':[36.99,-86.44],'owensboro':[37.77,-87.11],'paducah':[37.08,-88.60],
    'montgomery':[32.38,-86.30],'mobile':[30.69,-88.04],'huntsville':[34.73,-86.59],
    'tuscaloosa':[33.21,-87.57],'dothan':[31.22,-85.39],'auburn':[32.61,-85.48],
    'gulfport':[30.37,-89.09],'hattiesburg':[31.33,-89.29],'biloxi':[30.40,-88.89],'tupelo':[34.26,-88.70],
    'shreveport':[32.53,-93.75],'lake charles':[30.23,-93.22],'monroe':[32.51,-92.12],'alexandria la':[31.31,-92.44],
    'fort smith':[35.39,-94.40],'jonesboro':[35.84,-90.70],'hot springs':[34.50,-93.06],
    'tulsa':[36.15,-95.99],'norman':[35.22,-97.44],'lawton':[34.61,-98.39],'stillwater':[36.12,-97.06],
    'wichita':[37.69,-97.34],'topeka':[39.05,-95.68],'overland park':[38.98,-94.67],
    'lawrence':[38.97,-95.24],'salina':[38.84,-97.61],'dodge city':[37.75,-100.02],
    'kansas city ks':[39.11,-94.63],'joplin':[37.08,-94.51],'jefferson city':[38.58,-92.17],
    'washington dc':[38.90,-77.04],'baltimore':[39.29,-76.61],'annapolis':[38.98,-76.49],
    'frederick':[39.41,-77.41],'rockville':[39.08,-77.15],'silver spring':[38.99,-77.03],
    'salisbury':[38.36,-75.60],'ocean city':[38.34,-75.08],
    'virginia beach':[36.85,-75.98],'norfolk':[36.85,-76.29],'roanoke':[37.27,-79.94],
    'charlottesville':[38.03,-78.48],'fairfax':[38.85,-77.31],'leesburg':[39.12,-77.56],
    'lynchburg':[37.41,-79.14],'harrisonburg':[38.45,-78.87],'blacksburg':[37.23,-80.41],
    'morgantown':[39.63,-79.96],'huntington':[38.42,-82.44],'wheeling':[40.06,-80.72],
    'worcester':[42.26,-71.80],'cambridge':[42.37,-71.11],'lowell':[42.63,-71.32],
    'new bedford':[41.64,-70.93],'cape cod':[41.68,-70.29],'hyannis':[41.65,-70.28],
    'providence':[41.82,-71.41],'newport ri':[41.49,-71.31],'warwick':[41.70,-71.42],
    'new haven':[41.31,-72.93],'stamford':[41.05,-73.54],'bridgeport':[41.18,-73.20],
    'waterbury':[41.56,-73.04],'norwalk':[41.12,-73.41],'danbury':[41.39,-73.45],
    'newark':[40.74,-74.17],'newark nj':[40.74,-74.17],'newark de':[39.68,-75.75],
    'jersey city':[40.73,-74.07],'trenton':[40.22,-74.76],'princeton':[40.35,-74.66],
    'atlantic city':[39.36,-74.42],'edison':[40.52,-74.41],'cherry hill':[39.93,-75.03],
    'paterson':[40.92,-74.17],'toms river':[39.95,-74.20],'morristown':[40.80,-74.48],
    'manchester':[42.99,-71.46],'manchester nh':[42.99,-71.46],'nashua':[42.77,-71.47],
    'concord':[43.21,-71.54],'concord nh':[43.21,-71.54],'portsmouth':[43.07,-70.76],
    'bangor':[44.80,-68.77],'lewiston':[44.10,-70.21],'rutland':[43.61,-72.97],'montpelier':[44.26,-72.58],
    'wilmington':[39.75,-75.55],'wilmington de':[39.75,-75.55],'dover':[39.16,-75.52],'dover de':[39.16,-75.52],
    'san juan':[18.47,-66.11],'ponce':[18.01,-66.61]
  };

  /* [lat, lng, the name shown back to the visitor] */
  var STATE = {
    'alabama':[32.8,-86.8,'Alabama'],'al':[32.8,-86.8,'Alabama'],
    'alaska':[64.0,-152.0,'Alaska'],'ak':[64.0,-152.0,'Alaska'],
    'arizona':[34.0,-111.7,'Arizona'],'az':[34.0,-111.7,'Arizona'],
    'arkansas':[34.9,-92.4,'Arkansas'],'ar':[34.9,-92.4,'Arkansas'],
    'california':[36.8,-119.4,'California'],'ca':[36.8,-119.4,'California'],
    'colorado':[39.0,-105.5,'Colorado'],'co':[39.0,-105.5,'Colorado'],
    'connecticut':[41.6,-72.7,'Connecticut'],'ct':[41.6,-72.7,'Connecticut'],
    'delaware':[39.0,-75.5,'Delaware'],'de':[39.0,-75.5,'Delaware'],
    'florida':[28.6,-81.8,'Florida'],'fl':[28.6,-81.8,'Florida'],
    'georgia':[32.9,-83.4,'Georgia'],'ga':[32.9,-83.4,'Georgia'],
    'hawaii':[20.8,-156.3,'Hawaii'],'hi':[20.8,-156.3,'Hawaii'],
    'idaho':[44.4,-114.6,'Idaho'],'id':[44.4,-114.6,'Idaho'],
    'illinois':[40.0,-89.2,'Illinois'],'il':[40.0,-89.2,'Illinois'],
    'indiana':[39.9,-86.3,'Indiana'],'in':[39.9,-86.3,'Indiana'],
    'iowa':[42.0,-93.5,'Iowa'],'ia':[42.0,-93.5,'Iowa'],
    'kansas':[38.5,-98.4,'Kansas'],'ks':[38.5,-98.4,'Kansas'],
    'kentucky':[37.6,-85.3,'Kentucky'],'ky':[37.6,-85.3,'Kentucky'],
    'louisiana':[31.0,-92.0,'Louisiana'],'la':[31.0,-92.0,'Louisiana'],
    'maine':[45.4,-69.2,'Maine'],'me':[45.4,-69.2,'Maine'],
    'maryland':[39.0,-76.8,'Maryland'],'md':[39.0,-76.8,'Maryland'],
    'massachusetts':[42.3,-71.8,'Massachusetts'],'ma':[42.3,-71.8,'Massachusetts'],
    'michigan':[44.3,-85.4,'Michigan'],'mi':[44.3,-85.4,'Michigan'],
    'minnesota':[46.3,-94.3,'Minnesota'],'mn':[46.3,-94.3,'Minnesota'],
    'mississippi':[32.7,-89.7,'Mississippi'],'ms':[32.7,-89.7,'Mississippi'],
    'missouri':[38.4,-92.5,'Missouri'],'mo':[38.4,-92.5,'Missouri'],
    'montana':[47.0,-109.6,'Montana'],'mt':[47.0,-109.6,'Montana'],
    'nebraska':[41.5,-99.8,'Nebraska'],'ne':[41.5,-99.8,'Nebraska'],
    'nevada':[39.3,-116.6,'Nevada'],'nv':[39.3,-116.6,'Nevada'],
    'new hampshire':[43.7,-71.6,'New Hampshire'],'nh':[43.7,-71.6,'New Hampshire'],
    'new jersey state':[40.2,-74.7,'New Jersey'],'nj':[40.2,-74.7,'New Jersey'],
    'new mexico':[34.5,-106.1,'New Mexico'],'nm':[34.5,-106.1,'New Mexico'],
    'new york state':[42.9,-75.5,'New York State'],'ny':[42.9,-75.5,'New York'],
    'north carolina':[35.5,-79.4,'North Carolina'],'nc':[35.5,-79.4,'North Carolina'],
    'north dakota':[47.4,-100.5,'North Dakota'],'nd':[47.4,-100.5,'North Dakota'],
    'ohio':[40.3,-82.8,'Ohio'],'oh':[40.3,-82.8,'Ohio'],
    'oklahoma':[35.6,-97.5,'Oklahoma'],'ok':[35.6,-97.5,'Oklahoma'],
    'oregon':[43.9,-120.6,'Oregon'],'or':[43.9,-120.6,'Oregon'],
    'pennsylvania':[40.9,-77.8,'Pennsylvania'],'pa':[40.9,-77.8,'Pennsylvania'],
    'rhode island':[41.7,-71.6,'Rhode Island'],'ri':[41.7,-71.6,'Rhode Island'],
    'south carolina':[33.9,-80.9,'South Carolina'],'sc':[33.9,-80.9,'South Carolina'],
    'south dakota':[44.4,-100.2,'South Dakota'],'sd':[44.4,-100.2,'South Dakota'],
    'tennessee':[35.8,-86.4,'Tennessee'],'tn':[35.8,-86.4,'Tennessee'],
    'texas':[31.5,-99.3,'Texas'],'tx':[31.5,-99.3,'Texas'],
    'utah':[39.3,-111.7,'Utah'],'ut':[39.3,-111.7,'Utah'],
    'vermont':[44.1,-72.7,'Vermont'],'vt':[44.1,-72.7,'Vermont'],
    'virginia':[37.5,-78.8,'Virginia'],'va':[37.5,-78.8,'Virginia'],
    'washington state':[47.4,-120.5,'Washington State'],'wa':[47.4,-120.5,'Washington'],
    'west virginia':[38.6,-80.6,'West Virginia'],'wv':[38.6,-80.6,'West Virginia'],
    'wisconsin':[44.6,-89.7,'Wisconsin'],'wi':[44.6,-89.7,'Wisconsin'],
    'wyoming':[43.0,-107.6,'Wyoming'],'wy':[43.0,-107.6,'Wyoming'],
    'district of columbia':[38.9,-77.0,'Washington DC'],'dc':[38.9,-77.0,'Washington DC'],
    'puerto rico':[18.2,-66.4,'Puerto Rico'],'pr':[18.2,-66.4,'Puerto Rico']
  };

  /* Bare "washington", "new york" and "new jersey" are handled as cities or
     tour stops above, which is what people mean. These aliases keep the state
     readings reachable for anyone who spells it out. */
  STATE['washington'] = STATE['wa'];

  /* First two digits of a US ZIP to a representative point. */
  var ZIP = {
    '00':[18.4,-66.1],'01':[42.1,-72.6],'02':[42.36,-71.06],'03':[43.2,-71.5],'04':[43.8,-70.3],
    '05':[44.3,-72.6],'06':[41.6,-72.7],'07':[40.75,-74.2],'08':[40.0,-74.7],'09':[38.9,-77.0],
    '10':[40.75,-73.98],'11':[40.75,-73.6],'12':[42.65,-73.76],'13':[43.05,-76.15],'14':[42.89,-78.88],
    '15':[40.44,-79.99],'16':[41.4,-79.5],'17':[40.27,-76.88],'18':[41.2,-75.5],'19':[39.95,-75.17],
    '20':[38.9,-77.03],'21':[39.29,-76.61],'22':[38.8,-77.3],'23':[37.0,-76.6],'24':[37.27,-79.94],
    '25':[38.35,-81.63],'26':[39.3,-80.0],'27':[36.0,-79.5],'28':[35.23,-80.84],'29':[34.0,-81.0],
    '30':[33.75,-84.39],'31':[32.3,-82.5],'32':[29.5,-81.6],'33':[26.5,-80.6],'34':[27.2,-82.2],
    '35':[33.52,-86.80],'36':[31.5,-86.5],'37':[36.0,-85.5],'38':[35.15,-90.05],'39':[32.30,-90.18],
    '40':[38.25,-85.76],'41':[38.4,-83.0],'42':[37.0,-86.4],'43':[39.96,-83.00],'44':[41.50,-81.69],
    '45':[39.5,-84.3],'46':[39.77,-86.16],'47':[38.9,-86.9],'48':[42.33,-83.05],'49':[42.96,-85.67],
    '50':[41.59,-93.62],'51':[42.3,-95.5],'52':[41.98,-91.67],'53':[43.04,-87.91],'54':[44.7,-89.0],
    '55':[44.98,-93.27],'56':[45.9,-95.4],'57':[44.0,-99.0],'58':[47.3,-100.0],'59':[46.9,-110.0],
    '60':[41.9,-88.0],'61':[41.0,-89.5],'62':[38.8,-89.5],'63':[38.63,-90.20],'64':[39.10,-94.58],
    '65':[37.2,-93.3],'66':[38.9,-95.5],'67':[37.69,-97.34],'68':[41.26,-95.93],'69':[41.3,-100.5],
    '70':[29.95,-90.07],'71':[32.5,-93.0],'72':[34.75,-92.29],'73':[35.47,-97.52],'74':[36.15,-95.99],
    '75':[32.78,-96.80],'76':[32.76,-97.33],'77':[29.76,-95.37],'78':[30.0,-98.0],'79':[34.0,-101.5],
    '80':[39.74,-104.98],'81':[38.5,-107.5],'82':[42.8,-107.0],'83':[43.6,-114.0],'84':[40.76,-111.89],
    '85':[33.45,-112.07],'86':[35.2,-111.7],'87':[35.08,-106.65],'88':[32.3,-105.5],'89':[36.17,-115.14],
    '90':[34.05,-118.24],'91':[34.15,-118.0],'92':[33.2,-117.3],'93':[35.5,-119.4],'94':[37.7,-122.2],
    '95':[37.6,-121.5],'96':[21.3,-157.9],'97':[44.5,-122.5],'98':[47.6,-122.3],'99':[47.7,-117.4]
  };

  /* Comma free copies of the tour keys, so "charleston sc" reaches
     "charleston, sc". Also index each tour city by its bare name when that name
     is not already taken by something else. */
  var TOURN = {};
  Object.keys(TOUR).forEach(function (k) {
    var flat = k.replace(/,/g, ' ').replace(/\s+/g, ' ').trim();
    TOURN[flat] = TOUR[k];
    var bare = flat.replace(/\s+[a-z]{2}$/, '');
    if (bare && bare !== flat && !TOURN[bare] && !CITY[bare]) TOURN[bare] = TOUR[k];
  });

  function clean(s) {
    return String(s || '').toLowerCase()
      .replace(/[^a-z0-9, ]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function flatten(s) {
    return s.replace(/,/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function titleCase(s) {
    return s.replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); });
  }
  function cityHit(key) { return { pt: (TOURN[key] || CITY[key]), label: titleCase(key) }; }
  function stateHit(key) {
    var e = STATE[key];
    return { pt: [e[0], e[1]], label: e[2], broad: true };
  }

  function resolve(raw) {
    var q = clean(raw);
    if (!q) return null;

    var zip = q.match(/\b(\d{5})(?:\d{4})?\b/);
    if (zip && ZIP[zip[1].slice(0, 2)]) {
      return { pt: ZIP[zip[1].slice(0, 2)], label: zip[1], broad: true, zip: true };
    }

    var f = flatten(q);

    if (TOURN[f]) return cityHit(f);
    if (CITY[f]) return cityHit(f);
    if (STATE[f]) return stateHit(f);

    var toks = f.split(' ');
    var i, j, sub;

    /* Longest leading run that names a place. */
    for (i = toks.length; i > 0; i--) {
      sub = toks.slice(0, i).join(' ');
      if (TOURN[sub] || CITY[sub]) return cityHit(sub);
    }
    /* Any run anywhere, longest first, for "near Cleveland Ohio please". */
    for (i = 0; i < toks.length; i++) {
      for (j = toks.length; j > i; j--) {
        sub = toks.slice(i, j).join(' ');
        if (TOURN[sub] || CITY[sub]) return cityHit(sub);
      }
    }
    /* Multi word state names. */
    for (i = 0; i < toks.length; i++) {
      for (j = Math.min(i + 3, toks.length); j > i + 1; j--) {
        sub = toks.slice(i, j).join(' ');
        if (STATE[sub]) return stateHit(sub);
      }
    }
    /* Single state token last. */
    for (i = 0; i < toks.length; i++) {
      if (STATE[toks[i]]) return stateHit(toks[i]);
    }
    return null;
  }

  window.LAC_GEO = { TOUR: TOUR, TOURN: TOURN, CITY: CITY, STATE: STATE, ZIP: ZIP, resolve: resolve };
})();
